<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import type { ServerForm } from '~/types/servers'

const { t } = useI18n()
const dialogRef = inject('dialogRef') as any
const serverId = computed(() => dialogRef?.value?.data?.serverId)
const serversStore = useServersStore()

const formData = ref<ServerForm>({
  name: '',
  pin_code: '',
  employee_number: '',
  handles_togo: false,
  handles_delivery: false,
  active: true,
})

const formKey = ref(0)

async function handleSubmit(formDataFromForm: ServerForm): Promise<void> {
  if (!serverId.value) return

  const success = await serversStore.updateServer(serverId.value, formDataFromForm)
  if (success) {
    dialogRef.value?.close()
  }
}

async function fetchServerData() {
  if (!serverId.value) return

  try {
    const server = await serversStore.fetchServerById(serverId.value)

    if (server) {
      formData.value = {
        name: server.name,
        pin_code: server.pin_code || '',
        employee_number: server.employee_number || '',
        handles_togo: server.handles_togo,
        handles_delivery: server.handles_delivery,
        active: server.active,
      }
      formKey.value++
    }
  }
  catch (error) {
    console.error('Error fetching server:', error)
    useErrorToast('Failed to load server data')
  }
}

onMounted(async () => {
  await fetchServerData()
})
</script>

<template>
  
<FormKitLazyProvider config-file="true">
<FormKit
    id="server-edit-form"
    :key="formKey"
    class="flex"
    type="form"
    :value="formData"
    :actions="false"
    @submit="handleSubmit"
  >
    <div class="flex gap-3 justify-center">
      <div class="w-1/2">
        <FormKit
          type="text"
          :label="t('Name')"
          :placeholder="t('Maria Garcia')"
          validation="required"
          validation-visibility="live"
          name="name"
        />
        <FormKit
          type="text"
          :label="t('PIN Code')"
          :placeholder="t('4-6 digit PIN')"
          validation="required|number|length:4,6"
          :validation-messages="{
            number: t('PIN must contain only digits'),
            length: t('PIN must be 4-6 digits'),
          }"
          validation-visibility="live"
          name="pin_code"
          inputmode="numeric"
        />
        <FormKit
          type="text"
          :label="t('Employee Number')"
          :placeholder="t('Optional')"
          name="employee_number"
        />
        <FormKit
          type="checkbox"
          :label="t('Handles To-Go Orders')"
          name="handles_togo"
        />
        <FormKit
          type="checkbox"
          :label="t('Handles Delivery Orders')"
          name="handles_delivery"
        />
        <FormKit
          type="checkbox"
          :label="t('Active')"
          name="active"
        />
        <FormKit
          type="submit"
          :label="t('Update server')"
        />
      </div>
    </div>
  </FormKit>
</FormKitLazyProvider>

</template>
